import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Done icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Done } from '@sravni/design-system-icons'
 *
 * <Done />
 * ```
 */
var Done = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Done", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.736 17.5a7.5 7.5 0 0 1-7.5-7.5 7.5 7.5 0 0 1 7.5-7.5 7.5 7.5 0 0 1 7.5 7.5 7.5 7.5 0 0 1-7.5 7.5Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M14.07 8.334 9.903 12.5l-2.5-2.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Done };
//# sourceMappingURL=Done.js.map
